import { Injectable } from '@angular/core';
import { ReportesRequestService } from './request/reportes-request.service';

@Injectable({
  providedIn: 'root'
})
export class ServicioEncuestaCovidService {

  constructor(private requestUrl: ReportesRequestService) { }

  async getEncuestasRealizadas( obj: EncuestaCovidEntity) {
    try {
      const response = await this.requestUrl.getFilterRequest(
        'encuesta-covid/encuestas-realizadas',
        [
          obj.codigo,
          {
            'afiliado' : obj.uncoAfiliado
          }
        ]);
      return response;
    }catch(e) {
      console.log(`ServicioEncuestaCovidService.getEncuestasRealizadas() ${e}`);
    }
  }

  async getFormatoEncuesta(obj: EncuestaCovidEntity) {
    try {
      const response = await this.requestUrl.getRequest(
        'encuesta-covid/formato',
        [
          obj.codigo,
          {
            'procesoAsistencial' : obj.encuesta.id
          }
        ]);
      return response;
    }catch(e) {
      console.error('ServicioEncuestaCovidService.getFormatoEncuesta()', e);
    }
  }

}

export interface EncuestaCovidEntity {
  codigo ?: string;
  uncoAfiliado ?: number;
  uncoSede ?: number;
  uncoLogin ?: number;
  encuesta ?: EncuestaCovidRealizadasEntity;
}

export interface EncuestaCovidRealizadasEntity {
  id ?: number;
  fechaAtencion ?: number;
  resultadoEncuesta ?: number;
}

export interface EncuestaCovidFormatoEntity {
  id ?: number;
  descripcion ?: string;
  preguntas ?: EncuestaCovidPreguntaEntity[];
  respuestas ?: EncuestaCovidRespuestaEntity[];
}

export interface EncuestaCovidPreguntaEntity {
  id ?: number;
  orden ?: number;
  edadInicial ?: number;
  edadFinal ?: number;
  unidadInicial ?: string;
  unidadFinal ?: string;
  descripcion ?: string;
  sexo ?: string;
  preguntasDetalle: EncuestaCovidPreguntaDetalleEntity[];
}

export interface EncuestaCovidPreguntaDetalleEntity {
  id ?: number;
  idPadrePreguntaDetalle ?: number;
  orden ?: number;
  descripcion ?: string;
  sexo ?: string;
  tipoObjeto ?: EncuestaCovidTipoObjetoEntity;
  preguntasDetalleRelacion ?: EncuestaCovidPreguntaDetalleEntity[];
  resultado ?: EncuestaCovidRespuestaEntity;
}

export interface EncuestaCovidTipoObjetoEntity {
  unco ?: number;
  codigo ?: number;
  descripcion ?: string;
}

export interface EncuestaCovidRespuestaEntity {
  id ?: number;
  idFormatoPreguntaDetalle ?: number;
  resultado ?: string;
}